export default "__VITE_ASSET__D62TTKZr__"